import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import LargePopupRedirect from "../../../_utils/CommonPopups/CommonLargePopupRedirect";
import BeneficiaryAccountViewAll from "../../../../containers/Accounts/BeneficiaryAccount/BeneficiaryAccountViewAll";

const BeneAccountViewAllPopup = ({
  id,
  type,
  flow,
  accountType,
  subType,
  onClosepop,
  sourceDestiAcc,
  ispanbankRequired,
  associateAccount,
  associatepanNumber,
  associateIFSC,
  associateaccountNumber,
  activeType,
  setActiveType,
  remPan,
  setRemPan,
  remAccount,
  setRemAccount,
  remIFSC,
  setRemIFSC,
  typePanBank,
  onAccountSelect,
  onClose,
  setTxnPayLoad,
  txnPayLoad,
  setIsNeft,
  setIsImps,
  setIsRtgs,
  beneAccountId,
  BeneTxnAssocAcct,
  setAssociateModalOpen,
  associateTxn,
  setOpenInternalAssociate,
  setOpenBeneAssociate,
  showModalPopup,
  handleClick,
  setAlertPopUp,
  flowType,
  createDisabled,
  name1,
  onCardNavigate,
}) => {
  const navigate = useNavigate();

  const handleClosePopup = () => {
    if (onClose) {
      onClose();
    } else if (onClosepop) {
      onClosepop();
    }
    setRemAccount?.("");
    setRemPan?.("");
    setRemIFSC?.("");
  };

  const handleButtonClick = (dataItem) => {
    if (type === "viewAll") {
      onAccountSelect?.(
        dataItem.name.trim(),
        dataItem.bank_acc_no.trim(),
        dataItem.ifsc_code.trim(),
        dataItem.id,
      );
    } else {
      onAccountSelect?.(
        dataItem?.name.trim(),
        dataItem?.bank_acc_no.trim(),
        dataItem?.ifsc_code.trim(),
        dataItem?.bank_name,
        dataItem?.category,
        dataItem?.pan_no,
        dataItem?.id,
        dataItem?.labels,
        dataItem?.internal_account,
      );

      if (associateTxn === "associateTxn") {
        setOpenInternalAssociate?.(false);
      }
      if (BeneTxnAssocAcct) {
        setAssociateModalOpen?.(false);
      }
    }
  };

  const headerTitle = useMemo(() => {
    if (flowType === "scheduleCreate") {
      return "Beneficiary accounts";
    }
    if (flowType === "create") {
      return "Are you sure you want to create this account?";
    }
    if (
      accountType === "internal" ||
      accountType === "beneficiary" ||
      BeneTxnAssocAcct ||
      associateTxn === "associateTxn"
    ) {
      return "Associated accounts";
    }
    if (flow === "internalTxn") {
      return "Select destination account";
    }
    return "Select beneficiary account";
  }, [accountType, BeneTxnAssocAcct, associateTxn, flow, flowType]);

  const headersubtext = useMemo(() => {
    if (flowType === "create") return;
    if (flow === "internal") {
      return "The accounts listed below are linked to the selected internal account.";
    }
    if (accountType === "beneficiary") {
      return "The accounts listed below are linked to the selected beneficiary account.";
    }
    return "Only active (pending & approved) accounts are enabled for selection.";
  }, [flow, accountType, flowType]);

  return (
    <div>
      <LargePopupRedirect
        closeiconhandleFunction={handleClosePopup}
        isfullViewrequired={sourceDestiAcc ? true : false}
        ispanbankRequired={ispanbankRequired}
        togglepan={() => {
          setActiveType?.("pan");
          setRemPan?.(associatepanNumber);
          setRemAccount?.("");
          setRemIFSC?.("");
        }}
        toggleBank={() => {
          setActiveType?.("bank");
          setRemPan?.("");
          setRemAccount?.(associateaccountNumber);
          setRemIFSC?.(associateIFSC);
        }}
        fullviewbtnText="Register a new account"
        redirectHeader="Register a new account"
        fullviewhandleFunction={() => {
          handleClosePopup();
          navigate("/beneficiary_account_dashboard/create_beneficiary_account");
        }}
        redirectIcon={
          "https://q2pay.in/new_assets/common/settings/add_button_white.svg"
        }
        imgColor={"var(--text-primary)"}
        fullviewicon={ICONS?.REDIRECT}
        headerTitle={headerTitle}
        headersubtext={headersubtext}
        isbottomSectionneed={showModalPopup}
        bottomHeaderTextNeed={true}
        bottomHeaderText={
          "On creating a new account, it gets added to the list of active accounts below as a 'pending' account for the PAN and Bank provided."
        }
        confirmbtnrequired={showModalPopup}
        btnText={"Create"}
        isDisabled={createDisabled}
        isLoaderNeeded={true}
        isLoading={createDisabled}
        enabledBgColor={"var(--positive-act)"}
        enabledTextColor={"var(--text-primary)"}
        disabledBgColor={
          createDisabled ? "var(--positive-act)" : "var(--text-disabled)"
        }
        disabledTextColor={"var(--text-primary)"}
        outLineColor={""}
        hoverOption={"dark"}
        handleFunction={handleClick}
      >
        <BeneficiaryAccountViewAll
          id={id}
          type={type}
          subType={subType}
          typepop={"popup"}
          typePanBank={typePanBank}
          onClosepop={onClose}
          handleButtonClick={handleButtonClick}
          associateAccount={associateAccount}
          associatepanNumber={associatepanNumber}
          associateIFSC={associateIFSC}
          associateaccountNumber={associateaccountNumber}
          setOpenBeneAssociate={setOpenBeneAssociate}
          beneAccountId={beneAccountId}
          BeneTxnAssocAcct={BeneTxnAssocAcct}
          accountType={accountType}
          flow={flow}
          setTxnPayLoad={setTxnPayLoad}
          txnPayLoad={txnPayLoad}
          setIsNeft={setIsNeft}
          setIsImps={setIsImps}
          setIsRtgs={setIsRtgs}
          setAssociateModalOpen={setAssociateModalOpen}
          associateTxn={associateTxn}
          name1={name1}
          alertPop={"AlertPopAsso"}
          handleClick={handleClick}
          showModalPopup={showModalPopup}
          setAlertPopUp={setAlertPopUp}
          flowType={flowType}
          remPan={remPan}
          remAccount={remAccount}
          remIFSC={remIFSC}
          activeType={activeType}
          onCardNavigate={onCardNavigate}
        />
      </LargePopupRedirect>
    </div>
  );
};

export default BeneAccountViewAllPopup;
